import {
    handleRehydrateAction,
    handleRemoveAction,
    handleSubmitAction
} from '../../../core/store/helpers/reducer-helper';
import * as actions from './account-statistics.actions';
import { AccountStatistics } from './account-statistics.model';

export interface State {
    ids: Array<string>;
    entities: { [id: string]: AccountStatistics };
}

export const initialState: State = {
    ids: [],
    entities: {}
};

// tslint:disable-next-line:only-arrow-functions
export function reducer(state = initialState, action): State {
    switch (action.type) {
        case actions.SUBMIT: {
            return handleSubmitAction(state, action);
        }
        case actions.REHYDRATE: {
            return handleRehydrateAction(state, action);
        }
        case actions.REMOVE: {
            return handleRemoveAction(state, action);
        }
        default: {
            return state;
        }
    }
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/account-statistics/account-statistics.reducer.ts